import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import DeleteIcon from '@mui/icons-material/Delete';
import { Add } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const Archived = () => {
    const [dump, setDump] = useState([]);
    const [filteredDump, setFilteredDump] = useState([]);
    const [searchItem, setSearchItem] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        axios.get('http://stream.youradio.co.za:3002/getArchived').then((response) => {
            setDump(response.data);
            setFilteredDump(response.data); // Set initial filtered data
        });
    }, []);

    useEffect(() => {
        // Filter dump based on search term, and make it case-insensitive
        const filteredData = dump.filter((data) =>
            data.firstName.toLowerCase().includes(searchItem.toLowerCase()) ||
            data.lastName.toLowerCase().includes(searchItem.toLowerCase()) ||
            data.id_number.includes(searchItem)
        );
        setFilteredDump(filteredData);
    }, [searchItem, dump]);

    const handleInput = (e) => {
        setSearchItem(e.target.value); // Update search term
    };

    const handleDelete = (id) => {
        axios.post('http://stream.youradio.co.za:3002/handleDelete', { id }).then(() => {
            setDump((prev) => prev.filter((item) => item.id !== id)); // Update dump without reloading
        });
    };


    const mailLink = 'mailto:';
    const whatsappLink = 'https://wa.me/';

    return (
        <div style={{ width: '100%', height: '100vh' }}>
            <div style={{ width: '100%', height: 50, backgroundColor: 'whitesmoke', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                    <button onClick={() => navigate('/Home')}>Home</button>
                </div>
                <div style={{ width: '50%', float: 'right' }}>
                    <input
                        style={{ width: '70%', height: 30, borderRadius: 10, float: 'right' }}
                        placeholder='Search'
                        onChange={handleInput}
                    />
                </div>
            </div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>ID</TableCell>
                            <TableCell align="center">Name</TableCell>
                            <TableCell align="center">Surname</TableCell>
                            <TableCell align="center">Calling Name</TableCell>
                            <TableCell align="center">ID Number</TableCell>
                            <TableCell align="center">Email</TableCell>
                            <TableCell align="center">Number</TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredDump.map((val, key) => (
                            <TableRow key={val.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell component="th" scope="row">{key+1}</TableCell>
                                <TableCell align="center">{val.firstName}</TableCell>
                                <TableCell align="center">{val.lastName}</TableCell>
                                <TableCell align='center'>{val.calling_name}</TableCell>
                                <TableCell align="center">{val.id_number}</TableCell>
                                <TableCell align="center"><Link target='_blank' to={`${mailLink}${val.email}`}>{val.email}</Link></TableCell>
                                <TableCell align="center"><Link target='_blank' to={`${whatsappLink}${val.number}`}>{val.number}</Link></TableCell>
                                <TableCell align="center" style={{ cursor: 'pointer' }}><DeleteIcon onClick={() => handleDelete(val.id)} /></TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Box sx={{ height: 320, transform: 'translateZ(0px)', flexGrow: 1 }}>
                
            </Box>
        </div>
    );
};

export default Archived;
